import api from '../../../api';
import {
  EmailAccountId,
  EmailAccountWarmupFilters,
  EmailAccountWarmupSettingsPayload,
} from '../types';

export const getEmailAccountsInWarmup = async (
  options: EmailAccountWarmupFilters,
) =>
  api.get(`email-account/email-warmup`, {
    params: { ...options },
  });

export const getEmailAccountWarmupDeliverabilityReport = async ({
  id,
}: EmailAccountId) =>
  api.get(`email-account/email-warmup/deliverability/${id}`);

export const getEmailAccountWarmupList = async () =>
  api.get('email-account/email-warmup/list');

export const getEmailAccountWarmupSentReceivedReport = async ({
  id,
}: EmailAccountId) => api.get(`email-account/email-warmup/sent-received/${id}`);

export const getEmailAccountWarmupSettings = async ({ id }: EmailAccountId) =>
  api.get(`email-account/email-warmup/settings/${id}`);

export const saveEmailAccountWarmupSettings = async ({
  id,
  ...rest
}: EmailAccountWarmupSettingsPayload) =>
  api.patch(`email-account/email-warmup/settings/${id}`, rest);

export const turnOnOffEmailAccountWarmup = async ({ id }: EmailAccountId) =>
  api.patch(`email-account/email-warmup/${id}`);
